<template>
  <div class="form">
    <div class="form__content">
      <h1 class="extra-large-headline">Proof of address</h1>
      <p class="bodycopy">Please submit your proof of address document.</p>
    </div>
    <form @submit.prevent>
      <FileUploadField
        name="proofOfAddressDocument"
        label="Upload proof of address document"
        placeholder="Select or drag your file"
        iconType="DocumentCircle"
        :errors="form.proofOfAddressDocumentErrors"
        @updateFile="updateFile"
      />

      <ButtonBase
        :isDisabled="formHasErrors || globalStore.getIsFormLoading"
        :isLoading="globalStore.getIsFormLoading"
        @onButtonClick="handleFormSubmit"
      >
        Continue
      </ButtonBase>
    </form>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";

import { useGlobalStore } from "@/stores/globalStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

import useCustomerActions from "@/composables/api/useCustomerActions";
import useApiHelpers from "@/composables/api/helpers";

import FileUploadField from "@/components/ui/inputs/FileUploadField.vue";
import ButtonBase from "@/components/ui/buttons/ButtonBase.vue";
import useFormValidation from "@/composables/validations/useFormValidation";

const router = useRouter();
const globalStore = useGlobalStore();
const identityQueueStore = useIdentityQueueStore();
const { validateFileInput } = useFormValidation();
const { fetchCustomerId } = useCustomerActions();
const { postRequest } = useApiHelpers();

const form = ref({
  proofOfAddressDocument: [],
  proofOfAddressDocumentErrors: "",
});
const updateFile = (file) => {
  const fileValidationErrors = validateFileInput(
    "proofOfAddressDocument",
    file
  );
  form.value.proofOfAddressDocument = file;

  form.value.proofOfAddressDocumentErrors = fileValidationErrors;
};

const handleFormSubmit = async () => {
  const custId = await fetchCustomerId();
  const formData = new FormData();
  const docType = "proof_of_address";

  globalStore.setIsFormLoading(true);

  formData.set("documentFile", form.value.proofOfAddressDocument);
  formData.set("documentType", docType);
  formData.set("documentReference", custId);

  postRequest("documents", formData, () =>
    router.push(identityQueueStore.getNextIdentityRoute)
  );
};

const formHasErrors = computed(() => {
  const anyErrors = form.value.proofOfAddressDocumentErrors !== "";
  const anyFieldsEmpty = form.value.proofOfAddressDocument.length === 0;
  return anyErrors || anyFieldsEmpty;
});
</script>
<style lang="scss" scoped>
.form {
  .bodycopy {
    margin-bottom: 1rem;
    @include breakpoint($min-m) {
      margin-bottom: 1.5rem;
    }
  }
  &__selfie-instructions {
    list-style: unset;
    padding-inline: 1.5rem;

    li {
      font-size: $font-body;
      line-height: 1.5;
    }
  }
}
</style>
